interface TableFooterProps {
  children?: JSX.Element | (JSX.Element | null | undefined | boolean)[] | null | undefined | boolean;
}

function TableFooter({ children }: TableFooterProps) {
  return <tfoot>{children}</tfoot>;
}

export default TableFooter;
